import { UpdatePricingContainer } from 'components/pricing'
import { Helmet } from 'react-helmet'

const UpdatePricing = () => {
  return (
    <>
      <Helmet>
        <title>ORMS Update Pricing</title>
      </Helmet>
      <div>
        <UpdatePricingContainer />
      </div>
    </>
  )
}

export default UpdatePricing
